import { ErrorObject, Format } from 'ajv';

export enum FormatType {
  RichText = 'rich-text',
  JsonLogic = 'json-logic',
}

export interface FormatDefinition {
  name: string;
  format: Format;
}

export interface FormError extends ErrorObject {
  propertyName?: string;
}

export type UriIssueReason = 'emptyHref' | 'blockedProtocol' | 'invalidHref';

export interface UriIssue {
  reason: UriIssueReason;
  href?: string;
  subKey: 'enforceUriProtocols';
}
